import { AssistantAction } from './models';

export function readActionPayloadValue<T>(action: AssistantAction, key: string): T | undefined {
  const payload = action.payload as Record<string, unknown> | undefined;
  const value = payload ? payload[key] : undefined;

  if (value === undefined || value === null) return undefined;
  return value as T;
}

export function readNumberPayload(action: AssistantAction, key: string): number | undefined {
  const value = readActionPayloadValue<number | string>(action, key);
  if (value === undefined || value === null || value === '') return undefined;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function readBooleanPayload(action: AssistantAction, key: string): boolean | undefined {
  const value = readActionPayloadValue<boolean | string>(action, key);
  if (typeof value === 'boolean') return value;
  if (typeof value !== 'string') return undefined;

  const normalized = value.trim().toLowerCase();
  if (['true', 'yes', '1', 'on'].includes(normalized)) return true;
  if (['false', 'no', '0', 'off'].includes(normalized)) return false;
  return undefined;
}
